import { render, staticRenderFns } from "./CompanionOptionsTabs.vue?vue&type=template&id=686fb7e6&"
import script from "./CompanionOptionsTabs.vue?vue&type=script&lang=js&"
export * from "./CompanionOptionsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports